import { render, staticRenderFns } from "./dictionary_child.vue?vue&type=template&id=763cca54&scoped=true"
import script from "./dictionary_child.vue?vue&type=script&lang=js"
export * from "./dictionary_child.vue?vue&type=script&lang=js"
import style0 from "./dictionary_child.vue?vue&type=style&index=0&id=763cca54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763cca54",
  null
  
)

export default component.exports